import { Component, Fragment } from "react";

import Header from '../component/layout/header'
import PageHeader from '../component/layout/pageheader'
import AboutSection from '../component/section/about'
import SponsorSectionAbout from "../component/section/sponsor-about";
import HrShape from "../component/layout/hrshape";
import Footer from "../component/layout/footer";
import Mission from "../component/section/mission";
import Vision from "../component/section/vision";
import OurValues from "../component/section/values";

class AboutPage extends Component {
    render() { 
        return (
            <Fragment>
                <Header />
                <div className="padding-top"></div>
                <AboutSection imgUrl={'assets/images/about/F9-Logo.svg'} />
                <Mission />
                <Vision />
                <OurValues />
                <SponsorSectionAbout />
                <HrShape />
                <Footer />
            </Fragment>
        );
    }
}
 
export default AboutPage;